import { path, pathEq } from 'ramda';
import { HANDOFF_STATUS } from './reducer';

export const getFetching = pathEq(['handoff', 'status'], HANDOFF_STATUS.pending);
export const getBusy = pathEq(['handoff', 'status'], HANDOFF_STATUS.busy);
export const getError = pathEq(['handoff', 'status'], HANDOFF_STATUS.error);
export const getTimeout = pathEq(['handoff', 'status'], HANDOFF_STATUS.timeout);
export const getCart = path(['handoff', 'cart']);
export const getClient = path(['handoff', 'client']);
